import VerticalLayout from 'src/components/VerticalLayout';
import {
    ROUTE_PATH_EMAIL_COMPOSE,
    ROUTE_PATH_EMAIL_INBOX,
    ROUTE_PATH_EMAIL_MESSAGE_DETAIL,
    ROUTE_PATH_EMAIL_SENT,
    ROUTE_PATH_EMAIL_STARRED,
    ROUTE_PATH_EMAIL_TRASH,
} from '../constants';
import Mailer from '../pages';

const MAILBOX_MODULES = ['gd', 'wb', 'tp', 'cm'];

const adminRoutes = [
    {
        /**
         * One route entry keeps the mailbox mounted while the user moves
         * between folders, compose and message details.
         */
        path: [
            ROUTE_PATH_EMAIL_INBOX,
            ROUTE_PATH_EMAIL_SENT,
            ROUTE_PATH_EMAIL_TRASH,
            ROUTE_PATH_EMAIL_STARRED,
            ROUTE_PATH_EMAIL_COMPOSE,
            ROUTE_PATH_EMAIL_MESSAGE_DETAIL,
        ],
        component: Mailer,
        layout: VerticalLayout,
        type: 'admin',
        modules: MAILBOX_MODULES,
        title: 'Mailbox | SIP',
    },
];

export default adminRoutes;

export { adminRoutes };
